export enum TabType {
    Invoice = 'Invoice',
    Account = 'Account',
    Chart = 'Chart',
    ChartDetail = 'ChartDetail',
    VisitPanel = 'VisitPanel',
    TreatmentPlan = 'TreatmentPlan',
    TreatmentPlanDetail = 'TreatmentPlanDetail',
}
